<div class="flex-column gap">
    <app-service-settings-common
        [hideShareWithOtherServicesInput]="true"
        [settingsKey]="SERVICE_SETTINGS_SUGGESTION_TYPE_KEY"
        title="service.settings.sidebar.suggestion"
    ></app-service-settings-common>

    <app-service-complaint-type></app-service-complaint-type>
</div>
